//
//
//
//
//
//
//
//
//

import { useRoute, useRouter, watch, ref } from '@nuxtjs/composition-api';
import Notification from '~/components/Notification';
import {
  useApiError
} from '@bee-hole/coms';
import { useUiNotification } from '~/composables';
export default {
  name: 'BlankLayout',
  components: {
    Notification
  },
  setup(p, context) {
    const { root: { $nuxt, $i18n, $options: { $xreq } } } = context;
    $i18n.__baseUrl = 'https://' + $xreq.host;
    const { error } = useApiError();
    const notify = useUiNotification();
    const route = useRoute();
    const router = useRouter();
    const notificationId = ref();
    const handleActionClick = () => {
      notify.dismiss(notificationId.value);
      router.push(context.root.localePath('/my-account/History?open=2'));
    };
    watch(error, async () => {
      if (error.value.code === 61) {
      } else {
        if (error.value.code === 2201) {
          return false;
        }
        let action = {};
        if (error.value.code === 3208 || error.value.code === 3128) {
          action = {
            text: $nuxt.$t('go_to_see_prepid'),
            onClick: handleActionClick
          };
        }
        if (error.value?.message) {
          notificationId.value = notify.send({
            type: error.value.code === 0 ? 'success' : 'danger',
            message:
              (error.value.code !== 0 ? error.value.code + ': ' : '') +
              String($nuxt.$t(error.value.message)),
            persistent: true,
            time: error.value.time || 0,
            action
          });
        }
        if (error.value.image) {
          await notify.dismiss(notificationId.value);
          // 等待1秒
          await new Promise((resolve) => {
            setTimeout(() => {
              resolve();
            }, 300);
          });
          notificationId.value = notify.send({
            type: error.value.code === 0 ? 'info' : 'danger',
            image: error.value.image,
            persistent: false,
            time: error.value.time || 0,
            class: 'notificationImage',
            action,
            sku: error.value.sku
          });
        }
        action = {};
      }
    });
    return {
      route
    };
  }
};
